import { styled } from 'helpers';
import { DialogTitle } from '../DialogTitle';

export const SimpleModalTitleStyled = styled(DialogTitle)`
  padding: 34px 0 34px;
  margin: 0 32px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['A100']};
`;
